import { useEffect, useState } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

// Firmaets faste hentesteder, sortert på navn. Lesetilgang krever admin eller dispatcher.
export function useCarrierPickups(orgId) {
  const [state, setState] = useState({ pickups: [], loading: Boolean(orgId) });

  useEffect(() => {
    if (!orgId) {
      setState({ pickups: [], loading: false });
      return undefined;
    }
    return onSnapshot(
      collection(db, 'organizations', orgId, 'pickupLocations'),
      snap => setState({
        pickups: snap.docs.map(d => ({ id: d.id, ...d.data() })).sort((a, b) => String(a.name ?? '').localeCompare(String(b.name ?? ''))),
        loading: false,
      }),
      () => setState({ pickups: [], loading: false }),
    );
  }, [orgId]);

  return state;
}
